import React from 'react';
import FilterField from './FilterField';
import SelectField from './SelectField';

import CustomDatePicker from '../../components/CustomDatePicker';
import AsyncInput from '../../components/AsyncInput';
import InputSearch from '../../components/InputSearch';

const SearchBar = ({ inputs }) => {
  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-x-4 gap-y-2 mt-4 flex-wrap">
      {inputs.map((input, index) => {
        if (input.type === 'search') {
          return <AsyncInput key={index} {...input} />;
        }
        if (input.type === 'simpleSearch') {
          return <InputSearch key={index} {...input} showReset={true} />;
        }
        if (input.type === 'filter') {
          return <FilterField key={index} {...input} />;
        }
        if (input.type === 'select') {
          return <SelectField key={index} {...input} value={input.selectedOptions} onChange={input.setSelectedOptions} />;
        }
        if (input.type === 'date') {
          return <CustomDatePicker key={index} {...input} />;
        }
      })}
    </div>
  );
};
export default SearchBar;
